module.exports = __webpack_public_path__ + "static/media/background.ab89e6cf.png";